export default "__VITE_ASSET__BiwrXIh7__"